import { render } from "./LocationsTab.vue?vue&type=template&id=a247159a&scoped=true"
import script from "./LocationsTab.vue?vue&type=script&lang=js"
export * from "./LocationsTab.vue?vue&type=script&lang=js"

import "./LocationsTab.vue?vue&type=style&index=0&id=a247159a&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a247159a"]])

export default __exports__